import ManualCharacterForm from 'app/frontend/base/components/ManualCharacterForm'
import { useAddCandidate, useAddManualCandidate } from '../hooks'

type Props = {
  onCancel?: () => void
  onAdded?: () => void
  manual?: boolean
  inModal?: boolean
}

const CandidateForm = ({ onCancel, onAdded, manual, inModal }: Props) => {
  const ownMutation = useAddCandidate()
  const manualMutation = useAddManualCandidate()
  const { mutate, isPending } = manual ? manualMutation : ownMutation

  return (
    <ManualCharacterForm
      onSubmit={(values, reset) =>
        mutate(values, {
          onSuccess: () => {
            reset()
            onAdded?.()
          },
        })
      }
      isPending={isPending}
      onCancel={onCancel}
      submitLabel={inModal ? 'Add' : 'Add as candidate'}
      inModal={inModal}
    />
  )
}

export default CandidateForm
